import apiClient from "./apiClient";

const register = async (payload) => {
  const response = await apiClient.post("/auth/register", payload);
  return response.data;
};

const registerSeller = async (payload) => {
  return register({
    ...payload,
    accountType: "SELLER",
  });
};

const resendVerificationEmail = async () => {
  const response = await apiClient.post("/auth/send-verification-email");
  return response.data;
};

const AuthService = {
  register,
  registerSeller,
  resendVerificationEmail,
};

export default AuthService;

